import { Fragment, useCallback, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { setupScrollElement } from '@/functions/ui/scroller'
import { getTextColor } from '@/functions/common/helper'

const HorizontalSlider = ({ ...props }) => {
    const ref = useRef(null)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', changeScroll)
        }
    })

    const updateClass = className => {
        if (props.tagsOpened) return className + '-with-tags'
        else return className
    }

    function changeScroll() {
        let currentScrollPos = window.pageYOffset
        let current = ref.current
        //let maxScroll = document.body.scrollHeight - window.innerHeight

        if (current) {
            if (currentScrollPos > 10) {
                current.classList.remove(updateClass('horizontal-slider-normal'))
                current.classList.remove(updateClass('horizontal-slider-moved'))
                current.classList.add(updateClass('horizontal-slider-moved'))
            } else {
                current.classList.add(updateClass('horizontal-slider-normal'))
                current.classList.remove(updateClass('horizontal-slider-moved'))
                current.classList.remove(updateClass('horizontal-slider-normal'))
            }
        }
    }

    let dispatch = useDispatch()

    const scrollToCategory = useCallback(
        item => {
            setupScrollElement(dispatch, item.id)
        },
        [dispatch]
    )

    let colorChange = props.color
    if (colorChange === '#ffffff') colorChange = '#000000'

    return (
        <div className={`pb-16 lg:pb-16`}>
            <div className={`bg-turbo-grayer w-full fixed z-20`} ref={ref}>
                {props.categories && (
                    <div className="lg:container lg:mx-auto overflow-x-auto pb-3 pt-3 lg:pt-3 flex px-2 gap-2 xs:px-5 2xl:gap-5">
                        {props.categories.map(item => {
                            return (
                                <Fragment key={item.id}>
                                    <div
                                        style={{ color: getTextColor(props.color), backgroundColor: props.color }}
                                        className={`flex-shrink-0 px-3 py-2 rounded-full font-libre_franklin text-xs tracking-0-03em hover:cursor-pointer hover:brightness-95 active:brightness-90  2xl:text-xl 2xl:px-6 2xl:py-3`}
                                        onClick={() => scrollToCategory(item)}
                                    >
                                        {item.nameLabel}
                                    </div>
                                </Fragment>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}
export default HorizontalSlider
